import React, { useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangePin = () => {
  const Navigate = useNavigate();

  const _id = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");

  const [newPinValue, setNewPinValue] = useState("");
  const [oldPinValue, setOldPinValue] = useState("");
  const [showNewPin, setShowNewPin] = useState(false);
  const [showOldPin, setShowOldPin] = useState(false);

  // Validation errors
  const [errors, setErrors] = useState({ oldPin: "", newPin: "" });

  const validateForm = () => {
    let valid = true;
    const newErrors = { oldPin: "", newPin: "" };

    if (!oldPinValue) {
      newErrors.oldPin = "Old PIN is required.";
      valid = false;
    } else if (oldPinValue.length !== 4) {
      newErrors.oldPin = "Old PIN must be exactly 4 digits.";
      valid = false;
    }

    if (!newPinValue) {
      newErrors.newPin = "New PIN is required.";
      valid = false;
    } else if (newPinValue.length !== 4) {
      newErrors.newPin = "New PIN must be exactly 4 digits.";
      valid = false;
    }

    if (oldPinValue && newPinValue && oldPinValue === newPinValue) {
      newErrors.newPin = "New PIN must be different from old PIN.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const changePin = (e) => {
    e.preventDefault();

    if (!validateForm()) return; // stop if validation fails

    const formdata = {
      user_id: _id,
      old_pin: oldPinValue,
      new_pin: newPinValue,
    };

    axios
      .post(`${process.env.REACT_APP_API}website/change_pin`, formdata)
      .then((res) => {
        if (res.data.result) {
          toast.success(res.data.msg);
          setOldPinValue("");
          setNewPinValue("");
          setErrors({ oldPin: "", newPin: "" });
        } else {
          toast.error(res.data.msg || "Failed to change PIN.");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Incorrect Old PIN");
      });
  };

  return (
    <div>
      <div className="tab-pane fade active show" id="account-info" role="tabpanel">
        <div className="myaccount-content">
          <h3>Change Pin</h3>
          <div className="account-details-form">
            <div className="row">
              <div className="col-lg-12 col-sm-12 col-md-12">
                <form method="post" onSubmit={changePin}>
                  {/* OLD PIN */}
                  <div style={{ position: "relative", width: "100%" }}>
                    <label htmlFor="oldPin">Old PIN</label>
                    <input
                      type={showOldPin ? "text" : "password"}
                      name="oldPin"
                      placeholder="Old PIN"
                      maxLength="4"
                      value={oldPinValue}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 4) {
                          setOldPinValue(val);
                        }
                      }}
                      style={{
                        width: "100%",
                        paddingRight: "35px",
                        padding: "8px",
                        fontSize: "16px",
                        border: errors.oldPin ? "1px solid red" : "",
                      }}
                    />

                    {/* Eye icon */}
                    <span
                      onClick={() => setShowOldPin(!showOldPin)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: errors.oldPin ? "55%" : "72%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    >
                      {showOldPin ? <FaEyeSlash /> : <FaEye />}
                    </span>
                    {errors.oldPin && (
                      <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
                        {errors.oldPin}
                      </div>
                    )}
                  </div>

                  <br />

                  {/* NEW PIN */}
                  <div style={{ position: "relative", width: "100%" }}>
                    <label htmlFor="newPin">New PIN</label>
                    <input
                      type={showNewPin ? "text" : "password"}
                      name="newPin"
                      placeholder="New PIN"
                      maxLength="4"
                      value={newPinValue}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 4) {
                          setNewPinValue(val);
                        }
                      }}
                      style={{
                        width: "100%",
                        paddingRight: "35px",
                        padding: "8px",
                        fontSize: "16px",
                        border: errors.newPin ? "1px solid red" : "",
                      }}
                    />

                    {/* Eye icon */}
                    <span
                      onClick={() => setShowNewPin(!showNewPin)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: errors.newPin ? "55%" : "72%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#555",
                      }}
                    >
                      {showNewPin ? <FaEyeSlash /> : <FaEye />}
                    </span>
                    {errors.newPin && (
                      <div style={{ color: "red", fontSize: "14px", marginTop: "4px" }}>
                        {errors.newPin}
                      </div>
                    )}
                  </div>

                  <br />

                  <div className="col-12 text-start">
                    <button className="btn btn-dark" type="submit">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ChangePin;
